import {
  URL_PARAM_SHOW_COMMENT,
  getCommentPointerFromQueryParam,
} from '../logic';
import { useQueryParameter } from '../../../../../hooks/useQueryParameter';

export type Item = {
  id: string;
  showComments?: boolean;
  showItems?: boolean;
};

export const URL_PARAM_SHOW_ITEMS = 'showItems';

export const useSelectedItemWithComments = () => {
  const [showCommentQueryParam] = useQueryParameter(URL_PARAM_SHOW_COMMENT);
  const [showItemsQueryParam] = useQueryParameter(URL_PARAM_SHOW_ITEMS);
  const commentPointer = getCommentPointerFromQueryParam(showCommentQueryParam);

  return {
    defaultSelectedItem: commentPointer
      ? { id: commentPointer.recordId, showComments: true, showItems: false }
      : showItemsQueryParam
      ? { id: showItemsQueryParam, showComments: false, showItems: true }
      : null,
  };
};
